import { render, staticRenderFns } from "./EditPrebuiltForms.vue?vue&type=template&id=6be2e438&"
import script from "./EditPrebuiltForms.vue?vue&type=script&lang=ts&"
export * from "./EditPrebuiltForms.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports